import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Box, Typography } from '@mui/material';
import {
  GridActionsCellItem,
  GridColDef,
  GridRowsProp,
  DataGrid as MuiDataGrid,
} from '@mui/x-data-grid';

const rows: GridRowsProp = [
  {
    id: 1,
    target: 'พนักงาน',
    expectation:
      'ทิศทางการดำเนินธรุกิจ และผลการดำเนินงานของบริษัท จริยธรรมทางธุรกิจขององค์กร คุณภาพชีวิตของพนักงาน ค่าตอบแทน สวัสดิการ และผลประโยชน์ที่เหมาะสม',
    expectationResponse:
      'สื่อสารให้พนักงานรับทราบถึงทิศทางการดำเนินธุรกิจและผลการดำเนินงานของบริษัทฯ จัดอบรมเรื่องจริยธรรมทางธุรกิจ การต่อต้านการทุจริตคอร์รัปลัน และการพัฒนาด้านความยั่งยืนแก่พนักงาน ปรับโครงสร้างการกำหนดค่าตอบแทนและสวัสดิการต่าง ๆ อย่างเหมาะสม ดูแลความปลอดภัย และอาชีวอนามัยของพนักงาน',
  },
  {
    id: 2,
    target: 'ผู้ถือหุ้น',
    expectation:
      'การเติบโตอย่างยั่งยืนทางธุรกิจการจ่ายผลตอบแทนอย่างต่อเนื่องการเข้าถึงข้อมูลอย่างเท่าเทียม',
    expectationResponse:
      'รักษาความเป็นผู้นำในธุรกิจโทรศัพท์เคลื่อนที่และคงการเติบโตในระดับที่สูงของธุรกิจอินเทอร์เน็ตบ้านและธุรกิจบริการลูกค้าองค์กรพร้อมขยายธุรกิจไปสู่บริการด้านใหม่ๆที่มีศักยภาพในการเติบโตสูงเพื่อสร้างการรายได้ในรูปแบบใหม่ๆเช่นธุรกิจวิดีโอบริการสินเชื่อดิจิทัลธุรกิจประกันภัย เป็นต้นกำหนดนโยบายจ่ายปันผลที่ร้อยละ 70 และจ่ายปีละสองครั้งคะแนน Corporate Governance Report ระดับ“ดีเลิศ”จากสมาคมส่งเสริมสถาบันกรรมการบริษัทไทยสื่อสารผลการดำเนินงานรายไตรมาสอย่างสมำ่เสมอในทุกช่องทาง โดยเปิดเผยข้อมูลสำคัญอย่างครบถ้วนและทันเวลา ผ่านช่องทางการสื่อสารที่เหมาะสมตามประเภทของนักลงทุน/ผู้ถือหุ้น',
  },
];

const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', resizable: false },
  {
    field: 'target',
    headerName: 'กลุ่มผู้มีส่วนได้เสีย',
    minWidth: 150,
  },
  {
    field: 'expectation',
    headerName: 'ความคาดหวังของผู้มีส่วนได้เสีย',
    flex: 1,
    minWidth: 200,
  },
  {
    field: 'expectationResponse',
    headerName: 'การตอบสนองความคาดหวังของผู้มีส่วนได้เสีย',
    minWidth: 200,
    flex: 1,
  },
  {
    field: 'action',
    headerName: 'Action',
    type: 'actions',
    minWidth: 150,
    getActions: () => [
      <>
        <GridActionsCellItem icon={<EditOutlinedIcon />} label="Edit" />
        <GridActionsCellItem icon={<DeleteOutlinedIcon />} label="Delete" />
      </>,
    ],
  },
];

const DataGrid = () => {
  return (
    <Box>
      <Typography variant="h3">DataGrid</Typography>
      <MuiDataGrid
        rows={rows}
        columns={columns}
        getRowHeight={() => 'auto'}
        columnVisibilityModel={{
          id: false,
        }}
      />
    </Box>
  );
};

export default DataGrid;
